import { render, staticRenderFns } from "./ProgramList.vue?vue&type=template&id=0a200a1b&scoped=true"
import script from "./ProgramList.vue?vue&type=script&lang=js"
export * from "./ProgramList.vue?vue&type=script&lang=js"
import style0 from "./ProgramList.vue?vue&type=style&index=0&id=0a200a1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a200a1b",
  null
  
)

export default component.exports